import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { News, NewsQueryParams } from "../types";

interface NewsState {
  newsList: Array<News>;
  newsTotal: number;
  newsDetail: Array<News>;
}

const initialState: NewsState = {
	newsList: [],
	newsTotal: 0,
	newsDetail: [],
};

export const newsSlice = createSlice({
	name: "news",
	initialState,
	reducers: {
		setListNews: (state, action) => {
			state.newsList = action.payload.data.data;
			state.newsTotal = action.payload.data.total;
		},
		setDetailNews: (state, action) => {
			if(action.payload.data && action.payload.data?.length > 0) {
				state.newsDetail = action.payload.data.filter((item: News) => item.language !== 'vi')
			} else {
				state.newsDetail = action.payload.data
			}
		},
		deleteNews: (state, action) => {
			const { id } = action.payload;
			state.newsList = state.newsList.filter(el => el.id !== id);
			state.newsTotal = state.newsTotal - 1;
		},
		changeStatusNews: (state, action) => {
			const { id, status } = action.payload;
			const index = state.newsList.findIndex(el => el.id === id);
			state.newsList[index].status = status;
		},
	},
});

export const selectNewsList = (state: RootState) => state.news.newsList;
export const selectNewsTotal = (state: RootState) => state.news.newsTotal;
export const selectNewsDetail = (state: RootState) => state.news.newsDetail;

export const { setListNews, setDetailNews, deleteNews, changeStatusNews } =
  newsSlice.actions;

export interface GetListNewsAsyncPayload {
  query: NewsQueryParams;
	callback?: () => void;
}
export const getListNewsAsync = createAction(
	"news/getListNewsAsync",
	(payload: GetListNewsAsyncPayload) => ({
		payload: payload,
	}),
);

export interface GetDetailNewsAsyncPayload {
  id: string | undefined;
	callback: (news: News[]) => void;
}
export const getDetailNewsAsync = createAction(
	"news/getDetailNewsAsync",
	(payload: GetDetailNewsAsyncPayload) => ({
		payload,
	}),
);
export interface CreateMultipleNewsAsyncPayload {
  data: News[];
  callback?: () => void;
}

export const createMultipleNewsAsync = createAction(
	"news/createMultipleNewsAsync",
	(payload: CreateMultipleNewsAsyncPayload) => ({
		payload,
	}),
);

export interface UpdateMultipleNewsAsyncPayload {
  data: News[];
	callback?: () => void;
}

export const updateMultipleNewsAsync = createAction(
	"news/updateMultipleNewsAsync",
	(payload: UpdateMultipleNewsAsyncPayload) => ({
		payload,
	}),
);

export interface UpdateStatusNewsByGroupCodePayload {
  groupCode: string;
  status: number;
	callback?: () => void;
}
export const updateStatusNewsByGroupCodeAsync = createAction(
	"news/updateStatusNewsByGroupCodeAsync",
	(payload: UpdateStatusNewsByGroupCodePayload) => ({
		payload,
	}),
);

export default newsSlice.reducer;
